import {Component, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {NavigationComponent} from "../navigation/navigation.component";

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    styleUrl: './imprint.component.scss',
    imports: [
        NavigationComponent
    ]
})
export class ImprintComponent implements OnInit {

    currentYear!: number;

    ngOnInit(): void {
        this.currentYear = new Date().getFullYear();
    }

}
